import React from 'react'
import styled from 'styled-components'

import Image from '@/components/image'
import {Text} from '@/components/text'
import type {UnifiedSignupModalCroppedImageFragment} from '@/graphql-types'

import {Card} from '../components/card'

type CroppedImageProps = {
    slice: UnifiedSignupModalCroppedImageFragment
}

export const CroppedImage = ({slice}: CroppedImageProps) => {
    return (
        <Container>
            <StyledCard>
                <StyledText>{slice.primary.text}</StyledText>
                <Image image={slice.primary.image} />
            </StyledCard>
        </Container>
    )
}

const Container = styled.div`
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: ${({theme}) => theme.spacings.s56};
    justify-content: flex-end;
    align-items: flex-end;
`

const StyledCard = styled(Card)`
    position: relative;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    bottom: -1px;
    right: -1px;
    padding-top: ${({theme}) => theme.spacings.s36};
    padding-left: ${({theme}) => theme.spacings.s20};
`

const StyledText = styled(Text)`
    padding-inline: ${({theme}) => theme.spacings.s24};
    margin-bottom: ${({theme}) => theme.spacings.s24};
`
